(() => {
  const ROOT_SELECTOR = '.product-information media-gallery slideshow-component';

  const syncCaption = (component) => {
    const gallery = component.closest('media-gallery');
    const caption = gallery?.querySelector('[data-cgh-media-caption]');
    if (!caption) return;

    const scroller = component.querySelector('slideshow-slides');
    const active =
      scroller?.querySelector('slideshow-slide[aria-hidden="false"]') ||
      scroller?.querySelector('slideshow-slide');

    const media = active?.querySelector('.product-media');
    const image = media?.querySelector('img.product-media__image');
    const text = (image?.getAttribute('alt') || '').trim();

    caption.textContent = text;
    caption.classList.toggle('cgh-current-media-caption--empty', !text);
  };

  const syncHeight = (component) => {
    const scroller = component.querySelector('slideshow-slides');
    if (!scroller) return;

    const active =
      scroller.querySelector('slideshow-slide[aria-hidden="false"]') ||
      scroller.querySelector('slideshow-slide');

    if (!active) return;

    requestAnimationFrame(() => {
      const height = Math.ceil(active.getBoundingClientRect().height);
      if (height > 0) scroller.style.height = `${height}px`;
    });
  };

  const setup = (component) => {
    if (component.dataset.cghAdaptiveHeight === 'true') return;
    component.dataset.cghAdaptiveHeight = 'true';

    const scroller = component.querySelector('slideshow-slides');
    if (!scroller) return;

    scroller.style.alignItems = 'flex-start';
    scroller.style.overflowY = 'hidden';

    const slides = [...scroller.querySelectorAll('slideshow-slide')];

    const mutationObserver = new MutationObserver(() => {
      syncHeight(component);
      syncCaption(component);
    });
    slides.forEach((slide) => {
      mutationObserver.observe(slide, {
        attributes: true,
        attributeFilter: ['aria-hidden'],
      });
    });

    const resizeObserver = new ResizeObserver(() => syncHeight(component));
    slides.forEach((slide) => resizeObserver.observe(slide));

    scroller.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', () => syncHeight(component), { once: true });
    });

    syncHeight(component);
    syncCaption(component);
  };

  const init = (root = document) => {
    root.querySelectorAll(ROOT_SELECTOR).forEach(setup);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();